var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49458 7.17171L3.8515 4.64687C4.8752 3.3737 6.41075 2.6726 7.9807 2.66615C8.89042 2.65969 9.81949 2.89196 10.6647 3.38015C11.5981 3.92211 12.3078 4.70064 12.7594 5.5953L8.34416 5.36303C7.09465 5.28991 5.90535 5.99317 5.49458 7.17171ZM6.20214 7.9997C6.20214 8.99329 7.00647 9.79763 8.00006 9.79763C8.99365 9.79763 9.79798 8.99329 9.79798 7.9997C9.79798 7.00611 8.99365 6.20178 8.00006 6.20178C7.00647 6.20178 6.20214 7.00396 6.20214 7.9997ZM12.9745 6.08134L9.97003 6.23619C10.7851 7.18892 10.798 8.56317 10.112 9.61698L7.70112 13.3247C8.70116 13.3784 9.73131 13.1591 10.6647 12.6171C12.9745 11.2837 13.91 8.4879 12.9745 6.08134ZM5.54189 9.0234L3.53536 5.077C2.98695 5.91575 2.6665 6.92224 2.6665 7.9997C2.6665 10.6665 4.61927 12.8752 7.17207 13.2666L8.54202 10.5826C7.30326 10.8149 6.10751 10.1353 5.54189 9.0234Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.5b67191a4028ebe7f9fafc0bdebe2748.svg";
export { ForwardRef as ReactComponent };